import classNames from 'classnames';
import React, { FunctionComponent } from 'react';

export interface TicketNameProps {
    className?: Parameters<typeof classNames>[0];
    disabled?: boolean;
}

const TicketName: FunctionComponent<TicketNameProps> = ({
    children,
    className,
    disabled = false,
}) => {
    return (
        <div
            className={classNames(
                'eds-text-bm eds-text-weight--heavy',
                {
                    'eds-text-color--ui-500': disabled,
                    'eds-text-color--ui-800': !disabled,
                },
                className,
            )}
        >
            {children}
        </div>
    );
};

export default TicketName;
